import { render } from "./DashboardPerformance.vue?vue&type=template&id=ca5125c0"
import script from "./DashboardPerformance.vue?vue&type=script&lang=js"
export * from "./DashboardPerformance.vue?vue&type=script&lang=js"

import "./DashboardPerformance.vue?vue&type=style&index=0&id=ca5125c0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__